export default __webpack_public_path__ + "static/media/Life's a Beach.ae13179d.jpg";